export default __webpack_public_path__ + "static/media/gold-frame.4d072732.png";